import { faXmark, faCheck } from '@awesome.me/kit-3777c2145e/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { __ } from '../../utils/i18n.js';
import { Spinner } from '../Spinner/Spinner.js';
import { Button } from '../Button/Button.js';

const ProgressButton = /*#__PURE__*/ React.forwardRef(({ children, className, disabled, icon, loadingChildren = __("Folyamatban..."), doneChildren = __("Kész"), errorChildren = __("Hiba"), state, variant = "primary", rounded, title, ...props }, ref)=>{
    const iconOnly = rounded || !children;
    let finalChildren = children;
    let finalClassName = className;
    let finalDisabled = disabled;
    let finalIcon = icon;
    let finalVariant = variant;
    let finalTitle = title;
    switch(state){
        case "loading":
            finalChildren = loadingChildren;
            finalClassName += " btn-progress btn-loading";
            finalDisabled = true;
            finalIcon = /*#__PURE__*/ React.createElement(Spinner, null);
            break;
        case "done":
            finalChildren = doneChildren;
            finalClassName += " btn-progress";
            finalDisabled = true;
            finalIcon = /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                icon: faCheck
            });
            finalVariant = variant.includes("outline") ? "outline-success" : "success";
            break;
        case "error":
            finalChildren = errorChildren;
            finalClassName += " btn-progress";
            finalDisabled = true;
            finalIcon = /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                icon: faXmark
            });
            finalVariant = variant.includes("outline") ? "outline-danger" : "danger";
            break;
    }
    if (iconOnly) {
        finalTitle = finalChildren;
        finalChildren = null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        ref: ref,
        className: finalClassName,
        variant: finalVariant,
        icon: finalIcon,
        disabled: finalDisabled,
        rounded: rounded,
        title: finalTitle,
        ...props
    }, finalChildren);
});

export { ProgressButton };
//# sourceMappingURL=ProgressButton.js.map
